import Lottie from 'lottie-react';
import React, { memo } from 'react';
import loader from '../../assets/loader.json';
import styled from 'styled-components';

const PageLoader = memo(() => {
  return (
    <Container>
      <div className="w-[400px] flex flex-col items-center">
        <Lottie animationData={loader} loop={true} />
        <div className="h-[20px]" />
        <label className="text-[16px] font-semibold text-gray-500">Хайж байна ...</label>
      </div>
    </Container>
  );
});

const Container = styled.div`
  width: 800px;
  height: 800px;
  border: solid 1px #ffefee;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

PageLoader.displayName = 'PageLoader';

export { PageLoader };
